import { z } from "zod";
import { photoRoulettePeriodSchema } from "./config.js";
import { PHOTO_ROULETTE_MAX_NUMBER_OF_PHOTOS, PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS } from "./game.js";

export const photoRouletteEligibilitySchema = z.object({
	eligible: z.boolean(),
	photo_count: z.number().int().nonnegative(),
	distinct_authors: z.number().int().nonnegative(),
	member_count: z.number().int().nonnegative(),
	period: photoRoulettePeriodSchema.optional(),
});

export type PhotoRouletteEligibility = z.infer<typeof photoRouletteEligibilitySchema>;

export const photoRouletteEligibilityQuerySchema = z.object({
	period: photoRoulettePeriodSchema.optional(),
	number_of_photos: z.coerce.number().int().min(PHOTO_ROULETTE_MIN_NUMBER_OF_PHOTOS).max(PHOTO_ROULETTE_MAX_NUMBER_OF_PHOTOS).optional(),
});

export type PhotoRouletteEligibilityQuery = z.infer<typeof photoRouletteEligibilityQuerySchema>;
